import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpUtilityService } from './app-http-utility.service';
import { CurrentUser } from '../interface/current-user.interface';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  private readonly http = inject(HttpUtilityService);

  getCurrentUser(showLoader = true): Observable<CurrentUser> {
    return this.http.get<CurrentUser>('/Auth/GetCurrentUser', undefined, showLoader);
  }
}